import { HUGGINGFACE_PROVIDER } from "@/components/ModelParameters/constants";
import { mapProviderToDisplayName } from "@/components/ProviderDropdown/utils";
import { Provider } from "@/queries/models";

export const getProviders = (providers: Provider[], isEdit: boolean) => {
  const providersToShow = isEdit
    ? providers.filter(
        (provider) => provider.provider_name !== HUGGINGFACE_PROVIDER,
      )
    : providers;

  return providersToShow.map((provider) => ({
    label: mapProviderToDisplayName(provider.provider_name),
    value: provider.provider_name,
    id: provider.provider_name,
  }));
};

export const getModels = (providers: Provider[], provider: string) => {
  return providers
    .filter((p) => p.provider_name === provider)
    .flatMap((p) =>
      p.model_configs.filter((m) => !m.is_internal && !m.display_name),
    )
    .map((m) => ({
      label: m.llm_model_name,
      value: m.llm_model_name,
      id: m.llm_model_name,
    }));
};

export const getIsModelExists = (
  providers: Provider[],
  provider: string,
  modelName: string,
) => {
  return providers
    .filter((p) => p.provider_name === provider)
    .flatMap((p) => p.model_configs.filter((m) => !m.is_internal))
    .map((m) => m.display_name || m.llm_model_name)
    .includes(modelName);
};
